import flatten from 'flat';
import { useFormikContext } from 'formik';

export const ErrorBlock: React.FC = ({ children }) => {
  return (
    <div className="max-w-xl mx-auto">
      <div className="py-4 px-6 bg-red-50 border-red-300 border rounded">{children}</div>
    </div>
  );
};

export const ApiErrorBlock: React.FC<ApiErrorBlockApiProps> = ({ errors }) => {
  return (
    <ErrorBlock>
      <ul>
        {errors.map((error, index) => (
          <li key={`api-error-${index}`}>
            <div>
              <span className="text-red-700">{error.message}</span>
            </div>
          </li>
        ))}
      </ul>
    </ErrorBlock>
  );
};
export type ApiErrorBlockApiProps = {
  errors: { message: string }[];
};

export const ErrorBlockFormik = () => {
  const formik = useFormikContext<any>();

  return (
    <ErrorBlock>
      <ul>
        {Object.entries(flatten<typeof formik.errors, typeof formik.errors>(formik.errors))
          .filter(([, error]) => typeof error === 'string')
          .map(([key, error]) => (
            <li key={key}>
              <div>
                <span className="text-red-700">{error as string}</span>
              </div>
            </li>
          ))}
      </ul>
    </ErrorBlock>
  );
};
